import { render } from "./ComparisonQualityReport.vue?vue&type=template&id=6d2bed84&scoped=true"
import script from "./ComparisonQualityReport.vue?vue&type=script&lang=js"
export * from "./ComparisonQualityReport.vue?vue&type=script&lang=js"

import "./ComparisonQualityReport.vue?vue&type=style&index=0&id=6d2bed84&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2bed84"]])

export default __exports__
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtnGroup,QBtn,QTooltip,QDialog});
